module.exports = __webpack_public_path__ + "static/key-steps-to-reopening-the-workplace-f4ecb7b08d4aa29d91cb3c85775eab51.png";